module.exports = __webpack_public_path__ + "media/images/fallback/twitter_email_social_icons-bcdb6759cbf5717e64f63f176940c9c8.png";